import React, {Component} from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import {SkyLightStateless} from 'react-skylight';
import {Toolbar, Data} from 'react-data-grid-addons';
import {UI_HEIGHT} from '../Common/constants';
import {Grid, Row, Col, Panel, Button, ButtonGroup, Table, ButtonToolbar, Breadcrumb} from 'react-bootstrap';
import {Link} from 'react-router';
import {Doughnut} from 'react-chartjs';
import {Line} from 'react-chartjs-2';
import Time from '../Common/time'
import Spinner from '../Widgets/spinner';
import PurchaseQuoteModal from '../../containers/Purchase/purchaseQuoteModal';
import NewFavoriteModal from '../../containers/Favorites/favoriteModal';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import InputField from '../Common/inputField';
import { Field, FieldArray } from 'redux-form';
import { ROOT_URL } from '../../actions/root_url';

import { Translate, Localize } from 'react-redux-i18n';

class PurchaseManagerDashboard extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

            createReturnOpen: false,
            createQuoteOpen: false,
            createFavoriteOpen: false,

            // Data for last 30 days performance
            monthData: {
              labels: [],
              datasets: [
                {
                  label: "30 Day Performance",
                  fill: false,
                  lineTension: 0.1,
                  backgroundColor: "rgba(75,192,192,0.4)",
                  borderColor: "rgba(75,192,192,1)",
                  borderCapStyle: 'butt',
                  borderDash: [],
                  borderDashOffset: 0.0,
                  borderJoinStyle: 'miter',
                  pointBorderColor: "rgba(75,192,192,1)",
                  pointBackgroundColor: "#fff",
                  pointBorderWidth: 1,
                  pointHoverRadius: 5,
                  pointHoverBackgroundColor: "rgba(75,192,192,1)",
                  pointHoverBorderColor: "rgba(220,220,220,1)",
                  pointHoverBorderWidth: 2,
                  pointRadius: 1,
                  pointHitRadius: 10,
                  data: [],
                  spanGaps: false,
                }
              ]
            },

            // Array of purchasers performance in the last month
            purchasersPerformance: [],

            // Data for records table
            records: {
                rows: [],
                sortColumn: null,
                sortDirection: null
            },

            reports: {
                rows: [],
                sortColumn: null,
                sortDirection: null
            }
        };

        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.props.fetchPurchasersPerformance();
        this.props.fetchVendorRecords();
        this.props.fetchMonthPerformance();
        // this.props.fetchPurchaseOrderPerformance();
        this.props.fetchPurchaseManagerInfo();
        this.props.fetchIncidentReport();
        // this.props.fetchPurchaseOrders();
        // this.props.fetchInventories();
        // this.props.fetchFavorites();
        // this.props.fetchNumPurchaseQuotes();
        // this.props.fetchPurchaseOrdersNotReceived();
        // this.props.fetchTotalPurchases();
        //
        // this.props.fetchTodaysIncomingOrders();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once products are ready, reset state.

    componentWillReceiveProps(nextProps) {
        if (nextProps.vendorRecords && nextProps.vendorRecords != this.props.vendorRecords) {
            let records = { ...this.state.records, rows: nextProps.vendorRecords };
            this.setState({ records });
        }

        // if (nextProps.purchaseOrderPerformance && nextProps.purchaseOrderPerformance != this.props.purchaseOrderPerformance) {
        //     let labelData = JSON.parse(JSON.stringify(nextProps.purchaseOrderPerformance));
        //
        //     for (var property in labelData) {
        //         if (labelData.hasOwnProperty(property)) {
        //             console.log(property)
        //             console.log(property.substring(1,4))
        //         }
        //     }
        // }

        if (nextProps.lastMonth && nextProps.lastMonth != this.props.lastMonth) {
            let lastMonth = {...this.state.monthData};

            nextProps.lastMonth.forEach( day => {
              if (parseInt(day.Day) % 2 == 1)
                lastMonth.labels.push(day.Day);
              else
                lastMonth.labels.push('');
              lastMonth.datasets[0].data.push(day.Orders);
            })
            this.setState({ monthData: lastMonth });
        }

        if (nextProps.purchasersPerformance && nextProps.purchasersPerformance != this.props.purchasersPerformance) {
          let purchasersPerformance = [];

          nextProps.purchasersPerformance.forEach(record => {
            let lastMonth = new PurchaserRecord();
            lastMonth.datasets[0].label = record.User;
            record.Orders.forEach( day => {
              if (parseInt(day.Day) % 2 == 1)
                lastMonth.labels.push(day.Day);
              else
                lastMonth.labels.push('');
              lastMonth.datasets[0].data.push(day.Orders);
            });

            purchasersPerformance.push(lastMonth);
          });
          this.setState({ purchasersPerformance });
        }

        if (nextProps.incidentReport && nextProps.incidentReport != this.props.incidentReport) {
          let incidents = [...nextProps.incidentReport];
          let reports = {...this.state.reports, rows: incidents};
          this.setState({ reports });
        }
    }

    formatDate(date) {
      var monthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      if (date) {
        var month = String(date).slice(4,7);
        var day = String(date).slice(8,10);
        var year = String(date).slice(11, 15);

        let chosenDateFormatted = '';
        if ( parseInt(monthShortNames.indexOf(month) + 1) < 10) {
          chosenDateFormatted = chosenDateFormatted + '0' + (monthShortNames.indexOf(month)+1) + day;
        } else {
          chosenDateFormatted = chosenDateFormatted + (monthShortNames.indexOf(month)+1) + day;
        }
        chosenDateFormatted = chosenDateFormatted + year;
        return chosenDateFormatted;
      }
      return null;
    }

    handleResize(e) {
        this.setState({tableHeight: window.innerHeight - UI_HEIGHT.fourLineButton});
    }

    // Set product being selected to be currentProduct and navigate user to the edit page

    setCurrentPurchaseOrder(e) {
        e.preventDefault();
        const currentPurchaseOrder = this.state.selectedRows[0];
        this.props.resetCurrentPurchaseOrder();
        this.props.selectPurchaseOrder(currentPurchaseOrder);
        this.context.router.push('/purchaseOrder/' + currentPurchaseOrder.PurchaseOrder_id);
    }

    clickNew(e) {
        e.preventDefault();
        this.props.resetCurrentPurchaseOrder();
        this.context.router.push('/purchaseOrder/new')
    }

    // Render the table head and bind it to the datatable plugin to show a sortable table.

    renderMyNotificationReport() {
        if (this.props.incidentReportIsLoading && !this.props.incidentReportError) return <Spinner/>
        else if (this.props.incidentReportError) return <ContentWrapper>
            <div className="alert alert-danger">{JSON.stringify(this.props.incidentReportError)}</div>
        </ContentWrapper>
        else {
            // Parameters of the react-data-grid

            let tableHeight = (window.innerHeight < 900) ? 540 : 540;

            const getRows = () => {
                return Data.Selectors.getRows(this.state.reports);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var reports = {...this.state.reports, sortColumn, sortDirection};
                this.setState({ reports });
            }

            // Handle the row select function

            const onRowSelect = rows => {
                var reports = {...this.state.reports, selectedRows: rows};
                this.setState({ reports });
            }

            //Custom Formatter component

            const DateFormatter = React.createClass({
                render() {
                    if (this.props.value) {
                      let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                      let date = new Date(this.props.value)
                      let index = dateMap.indexOf(date.toString().slice(4,3));
                      let localDate = index + date.toString().slice(8, 6);
                      return <span>{date.toString().slice(4, 15)}</span>;;
                    }
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNumFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
                {
                    key: 'Note_for_Change',
                    name: <Translate value="action" />,
                    resizable: true,
                    sortable: true,
                },
                {
                    key: 'Modifier_Username',
                    name: <Translate value="user" />,
                    resizable: true,
                    sortable: true,
                    width: 80
                },
                {
                    key: 'TotalPrice',
                    name: <Translate value="check" />,
                    resizable: true,
                    sortable: true,
                    width: 80
                }
            ]

            return (
              //React Table Notifications
                <Row>
                  <Col sm={ 12 }>
                    <div id="PurchaseManagerDashboard-dataGrid1">
                        <ReactDataGrid
                            rowKey='log_version_id'
                            onGridSort={handleGridSort}
                            columns={columns}
                            rowGetter={rowGetter}
                            rowsCount={getSize() }
                            minHeight={tableHeight}
                            rowHeight={25}
                            onRowSelect={onRowSelect}/>
                    </div>
                </Col>
              </Row>
            )
        }
    }

    renderMyVendors() {
        if (this.props.vendorRecordsIsLoading && !this.props.vendorRecordsError) return <Spinner/>
        else if (this.props.vendorRecordsError) return <ContentWrapper>
            <div className="alert alert-danger">{JSON.stringify(this.props.vendorRecordsError)}</div>
        </ContentWrapper>
        else {
            // Parameters of the react-data-grid
            let tableHeight = (window.innerHeight < 900) ? 540 : 540;
            // const getRows = () => {
            //     return Data.Selectors.getRows(this.state.inventories);
            // }

            const getRows = () => {
                return Data.Selectors.getRows(this.state.records);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            const handleGridSort = (sortColumn, sortDirection) => {
                var records = {...this.state.records, sortColumn, sortDirection};
                this.setState({records});
            }

            const onRowSelect = rows => {
                var records = {...this.state.records, selectedRows: rows};
                this.setState({ records });
            }

            //Custom Formatter component

            const DateFormatter = React.createClass({
                render() {
                    if (this.props.value) {
                      let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                      let date = new Date(this.props.value)
                      let index = dateMap.indexOf(date.toString().slice(4,3));
                      let localDate = index + date.toString().slice(8, 6);
                      return <span>{date.toString().slice(4, 15)}</span>;;
                    }
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNumFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            const OutstandingFormatter = React.createClass({
                render() {
                    if (this.props.value) return (
                        <div style={{marginTop:'20px'}}>
                          <span className="label label-danger">${this.props.value}</span>
                        </div>
                      )
                    else return <span>-</span>
                }
            });

            const OrderAmountFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span className="label label-primary">${this.props.value}</span>
                    else return <span>-</span>
                }
            })

            // Column difinition

            const columns = [
                {
                    key: 'Name',
                    name: <Translate value="name" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'OrderAmount',
                    name: <Translate value="order_amount" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    formatter: OrderAmountFormatter,
                    width: 125
                },
                {
                    key: 'OutstandingInvoices',
                    name: <Translate value="invoice" />,
                    resizable: true,
                    sortable: true,
                    formatter: OutstandingFormatter,
                    width: 100
                }
            ]

            return (
              //React Table Vendors
                <Row>
                  <Col sm={ 12 }>
                    <div id="PurchaseManagerDashboard-dataGrid2">
                        <ReactDataGrid
                            rowKey='Vendor_id'
                            onGridSort={handleGridSort}
                            columns={columns}
                            rowGetter={rowGetter}
                            rowsCount={getSize() }
                            minHeight={tableHeight}
                            rowHeight={25}
                            onRowSelect={onRowSelect}/>
                    </div>
                </Col>
              </Row>
            )
        }
    }

    renderDatePicker(handleSubmit) {
      return (
        <form onSubmit={handleSubmit}>
          <Field name="SelectedDate" component={ DatePicker } />
        </form>
      )
    }

    renderUndoPriceAdjust() {
      if (this.props.purchaseManagerInfoIsLoading && !this.props.purchaseManagerInfoError) return <Spinner/>
      else if (this.props.purchaseManagerInfoError) {
        return <ContentWrapper>
              <div className="alert alert-danger">{JSON.stringify(this.props.purchaseManagerInfoError)}</div>
          </ContentWrapper>
      }
      else {
        return (
          <div className="dash-number">{this.props.purchaseManagerInfo.Undo}</div>
        )
      }
    }

    renderPurchaseWarning() {
      if (this.props.purchaseManagerInfoIsLoading && !this.props.purchaseManagerInfoError) return <Spinner/>
      else if (this.props.purchaseManagerInfoError) {
        return <ContentWrapper>
              <div className="alert alert-danger">{JSON.stringify(this.props.purchaseManagerInfoError)}</div>
          </ContentWrapper>
      }
      else {
        return (
          <div className="dash-number">{this.props.purchaseManagerInfo.Warning}</div>
        )
      }
    }


    renderMonthPerformance() {
      if (this.props.lastMonthIsLoading && !this.props.lastMonthError) return <Spinner />
      else if (this.props.lastMonthError) {
        return <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.lastMonthError)}</div>
        </ContentWrapper>
      }
      else {
        return (
          <div><Line data={this.state.monthData} height={260} options={{ maintainAspectRatio: false }}/></div>
        )
      }
    }

    render() {
        const { handleSubmit, numPurchaseQuotes } = this.props;
        let height = (this.state.tableHeight+ 90).toString();
        let tableCollapseFix = {height: height};
        let graphCollapseFix = {height: ((this.state.tableHeight+ 85)/2).toString()}
        // Dummie Data

        var data = {
            labels: ["January", "February", "March", "April", "May", "June", "July"],
            datasets: [
                {
                    label: "My First dataset",
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: "rgba(75,192,192,0.4)",
                    borderColor: "rgba(75,192,192,1)",
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: "rgba(75,192,192,1)",
                    pointBackgroundColor: "#fff",
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: "rgba(75,192,192,1)",
                    pointHoverBorderColor: "rgba(220,220,220,1)",
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: [65, 59, 80, 81, 56, 55, 40],
                    spanGaps: false,
                }
            ]
        };

        var options = {
          maintainAspectRatio: false,
          scales: {
              xAxes: [{
                  ticks: {
                      fixedStepSize: 2
                  }
              }]
          }
        }

        const notificationTablePanelHeader = ( <h4><Translate value="illegal_operations_report" /></h4> );
        const panelHeader = ( <h4><Translate value="my_vendors" /></h4> );
        const purchaseReceiveDate = ( <h4><Translate value="purchase_order_receive_rate" /></h4> );
        const overallPurchaseReceiveRate = ( <h4><Translate value="overall_purchase_receive_rate" /></h4> );
        return (
          //---------------
          // Begin HTML
          //---------------
            <ContentWrapper>
              <Breadcrumb>
                <Breadcrumb.Item active="true">
                  <Translate value="purchase_manager_dashboard" />
                </Breadcrumb.Item>
              </Breadcrumb>

              <Grid id="purchase-manager-dashboard" fluid="true">
                {/* Dashboard Panels */}
                <h1><Translate value="purchase_manager_dashboard" /></h1>
                <Row>
                    <Time />
                    <div className="col-sm-5ths">
                        <Link to="/priceAdjustmentReport">
                            <div className="panel widget">
                                <Row className="row-table">
                                    <Col sm={ 5 } className="bg-blue">
                                      {this.renderUndoPriceAdjust()}
                                    </Col>
                                    <Col sm={ 7 }>
                                      <h3><Translate value="price_adjustment" /></h3>
                                    </Col>
                                </Row>
                            </div>
                        </Link>
                    </div>

                    <div className="col-sm-5ths">
                        <Link to="/purchaseReferencereport">
                            <div className="panel widget">
                                <Row className="row-table">
                                    <Col sm={ 5 } className="bg-red">
                                      {this.renderPurchaseWarning()}
                                    </Col>
                                    <Col sm={ 7 }>
                                      <h3><Translate value="purchase_reference" /></h3>
                                    </Col>
                                </Row>
                            </div>
                        </Link>
                    </div>

                    <div className="col-sm-5ths">
                      <Link to="/purchasingPerformanceReport">
                        <div className="panel widget">
                            <Row className="row-table">
                                <Col sm={ 5 } className="bg-yellow">
                                </Col>
                                <Col sm={ 7 }>
                                  <h3><Translate value="purchase_performance" /></h3>
                                </Col>
                            </Row>
                        </div>
                      </Link>
                    </div>

                    <div className="col-sm-5ths">
                      <Link to="/purchasePivotChart">
                        <div className="panel widget">
                            <Row className="row-table">
                                <Col sm={ 5 } className="bg-green">
                                </Col>
                                <Col sm={ 7 }>
                                  <h3><Translate value="purchase_pivot_chart" /></h3>
                                </Col>
                            </Row>
                        </div>
                      </Link>
                    </div>
                </Row> {/* End Dashboard Panels */}

                {/* Tables */}
                <Row>
                    <Col sm={ 4 }>
                      <Panel header={notificationTablePanelHeader} className="table-collapse-fix purchase-manager-headings">
                        {this.renderMyNotificationReport() }
                      </Panel>
                    </Col>
                    <Col sm={ 4 }>
                      <Panel header={panelHeader} className="table-collapse-fix purchase-manager-headings">
                        {this.renderMyVendors() }
                      </Panel>
                    </Col>
                    <Col sm={ 4 }>
                      <Panel header={overallPurchaseReceiveRate} className="purchase-receive-date-chart">
                        {this.renderMonthPerformance()}
                      </Panel>
                      <Panel header={purchaseReceiveDate} className="purchase-receive-date-chart">
                          {
                              this.state.purchasersPerformance.map((item) => (
                                  <div><Line data={item} height={260} options={options}/></div>
                              ))
                          }
                      </Panel>
                    </Col>
                </Row> {/* End Tables */}
              </Grid>

            </ContentWrapper>
          //---------------
          // End HTML
          //---------------
        );
    }
}


export default PurchaseManagerDashboard;


function PurchaserRecord() {
  this.labels = [],
  this.datasets = [
    {
      label: "30 Day Performance",
      fill: false,
      lineTension: 0.1,
      backgroundColor: "rgba(75,192,192,0.4)",
      borderColor: "rgba(75,192,192,1)",
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: "rgba(75,192,192,1)",
      pointBackgroundColor: "#fff",
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: "rgba(75,192,192,1)",
      pointHoverBorderColor: "rgba(220,220,220,1)",
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 10,
      data: [],
      spanGaps: false,
    }
  ]
}



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/purchaseManagerDashboard.jsx